var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import linker from '../linker';
import { showErrorToUser, } from '../central/showError';
import { CloseIcon, SearchTag } from './atoms';
import { SearchControl } from './molecules';
import SearchSuggestionService from '../services/searchSuggestionService';
var SearchBox = (function (_super) {
    __extends(SearchBox, _super);
    function SearchBox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showOverlay = false;
        _this.searchSuggestions = [];
        return _this;
    }
    Object.defineProperty(SearchBox.prototype, "logoUrl", {
        get: function () {
            return _spPageContextInfo.webAbsoluteUrl + "/_layouts/15/images/RUB/Serviceportal/rub-logo.png";
        },
        enumerable: true,
        configurable: true
    });
    SearchBox.prototype.mounted = function () {
        this.load();
    };
    SearchBox.prototype.load = function () {
        var _this = this;
        SearchSuggestionService.instance
            .loadSearchSuggestionList()
            .then(function (result) {
            _this.searchSuggestions = result.map(function (item) {
                return {
                    label: item,
                };
            });
        })
            .catch(function (error) { return showErrorToUser(error); });
    };
    SearchBox.prototype.toggleOverlay = function () {
        this.showOverlay = !this.showOverlay;
    };
    SearchBox.prototype.search = function (term) {
        if (term) {
            SearchSuggestionService.instance.loadSearchResultUrl().then(function (url) {
                window.location.href = url + "?k=" + encodeURIComponent(term);
            });
        }
        this.resetSearch();
    };
    SearchBox.prototype.resetSearch = function () {
        this.showOverlay = false;
    };
    SearchBox = __decorate([
        Component({
            components: {
                CloseIcon: CloseIcon,
                SearchTag: SearchTag,
                SearchControl: SearchControl,
            },
        })
    ], SearchBox);
    return SearchBox;
}(Vue));
export default SearchBox;
linker.register('searchBox', SearchBox);
